import snakeCaseKeys from "snakecase-keys";

import {
  onCreateAddress,
  onDeleteAddress,
  onGetAddressAvailableList,
  onGetAddressDetail,
  onGetAddressPage,
  onUpdateAddress,
  onUpdateAddressStatus,
} from "../../services/apis/numbers";

const {
  createSlice,
  createAsyncThunk,
  createSelector,
} = require("@reduxjs/toolkit");

export const doCreateAddress = createAsyncThunk(
  "address/doCreateAddress",
  async params => {
    const result = await onCreateAddress(params);
    if (!result) {
      return;
    }
    return result;
  }
);

export const doUpdateAddress = createAsyncThunk(
  "address/doUpdateAddress",
  async params => {
    const request = snakeCaseKeys(params);
    const id = params.id;
    const result = await onUpdateAddress(id, request);
    if (!result) {
      return;
    }
    return result;
  }
);

export const doUpdateAddressStatus = createAsyncThunk(
  "address/doUpdateAddressStatus",
  async ({ id, params }) => {
    const result = await onUpdateAddressStatus(id, params);
    if (!result) {
      return;
    }
    return result;
  }
);

export const doDeleteAddress = createAsyncThunk(
  "address/doDeleteAddress",
  async id => {
    const result = await onDeleteAddress(id);
    if (!result) {
      return;
    }
    return result;
  }
);

export const doGetAddressPage = createAsyncThunk(
  "address/doGetAddressPage",
  async (params, { dispatch }) => {
    const request = snakeCaseKeys(params);
    Object.keys(request).forEach(
      k =>
        (request[k] =
          typeof request[k] == "string"
            ? request[k]
                .trim()
                .replaceAll(/&/g, "&amp;")
                .replaceAll(/>/g, "&gt;")
                .replaceAll(/</g, "&lt;")
                .replaceAll(/"/g, '"')
                .replaceAll(/\\/g, "\\\\")
            : request[k])
    );
    const result = await onGetAddressPage(request);
    if (!result) {
      return;
    }
    dispatch(setNumberOfElements(result.numberOfElements));
    return result;
  }
);

export const doGetAddressAvailableList = createAsyncThunk(
  "address/doGetAddressAvailableList",
  async params => {
    const result = await onGetAddressAvailableList(snakeCaseKeys(params));
    if (!result) {
      return;
    }
    return result.data;
  }
);

export const doGetAddressDetail = createAsyncThunk(
  "address/doGetAddressDetail",
  async id => {
    const result = await onGetAddressDetail(id);
    if (!result) {
      return;
    }
    return result;
  }
);

const initialState = {
  isSaving: false,
  serviceId: "",
  serviceNumber: "",
};

const slice = createSlice({
  name: "address",
  initialState: initialState,
  reducers: {
    setNumberOfElements: (state, action) => {
      state.numberOfElements = action.payload;
    },
    setServiceId: (state, action) => {
      state.serviceId = action.payload;
    },
    setServiceNumber: (state, action) => {
      state.serviceNumber = action.payload;
    },
  },
  extraReducers: {
    [doCreateAddress.pending]: state => {
      state.isSaving = true;
    },
    [doCreateAddress.fulfilled]: state => {
      state.isSaving = false;
    },
    [doCreateAddress.rejected]: state => {
      state.isSaving = false;
    },
    [doUpdateAddress.pending]: state => {
      state.isSaving = true;
    },
    [doUpdateAddress.fulfilled]: state => {
      state.isSaving = false;
    },
    [doUpdateAddress.rejected]: state => {
      state.isSaving = false;
    },
    [doDeleteAddress.pending]: state => {
      state.isSaving = true;
    },
    [doDeleteAddress.fulfilled]: state => {
      state.isSaving = false;
    },
    [doDeleteAddress.rejected]: state => {
      state.isSaving = false;
    },
    [doGetAddressPage.pending]: state => {
      state.isSaving = true;
    },
    [doGetAddressPage.fulfilled]: (state, action) => {
      state.isSaving = false;
      state.list = action?.payload?.content || [];
    },
    [doGetAddressPage.rejected]: state => {
      state.isSaving = false;
      state.list = [];
    },
  },
});

const { reducer, actions } = slice;
const { setNumberOfElements } = actions;
export const { setServiceId, setServiceNumber } = actions;

export default reducer;

export const isSaving = createSelector(
  state => state.address.isSaving,
  isSaving => isSaving
);

export const numOfEls = createSelector(
  state => state.address.numberOfElements,
  numberOfElements => numberOfElements
);

export const addressList = createSelector(
  state => state.address.list,
  list => list
);

export const getServiceId = createSelector(
  state => state.address.serviceId,
  serviceId => serviceId
);

export const getServiceNumber = createSelector(
  state => state.address.serviceNumber,
  serviceNumber => serviceNumber
);
